import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../redux/actions/modalActions";
import "./Modal.css";

const Modal = () => {
  const dispatch = useDispatch();
  const { isOpen, title, content } = useSelector((state) => state.modalReducer);

  useEffect(() => {
    if (!isOpen) return;

    const body = document.body;
    const previousOverflow = body.style.overflow;
    const previousPaddingRight = body.style.paddingRight;

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    const currentCount = Number(body.dataset.modalOpenCount || 0);
    body.dataset.modalOpenCount = String(currentCount + 1);

    if (currentCount === 0) {
      body.style.overflow = "hidden";
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    return () => {
      const nextCount = Math.max(
        0,
        Number(body.dataset.modalOpenCount || 1) - 1,
      );
      body.dataset.modalOpenCount = String(nextCount);

      if (nextCount === 0) {
        body.style.overflow = previousOverflow;
        body.style.paddingRight = previousPaddingRight;
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <div className="modal-overlay " onClick={handleClose}>
      <div
        className="modal-content modal-scroll"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="modal-body">{content}</div>
      </div>
    </div>
  );
};

export default Modal;
